import { yupResolver } from "@hookform/resolvers/yup";
import React, { useCallback } from "react";
import { useForm } from "react-hook-form";
import { sendOtpFormSchema } from "../../validations";
import Button from "../controls/Button";
import TextBox from "../controls/TextBox";

interface Props {
  forUsername: boolean;
  title?: string;
  label?: string;
  type?: "text" | "password" | "number";
  className?: string;
  value?: string;
  isBusy?: boolean;
  isDisabled?: boolean;
  info?: React.ReactNode;
  maxLength?: number;
  min?: number;
  max?: number;
  //onSendOtp?: (val: string) => Promise<void> | undefined;
  onSendOtp?: (mobileNum: string) => void;
}

const SendOtpForm = (props: Props) => {
  const {
    forUsername = true,
    title = "",
    label = "",
    min,
    max,
    maxLength,
    isBusy,
    isDisabled,
    className,
    value = "",
    onSendOtp,
    type = "text",
    info,
  } = props;

  const {
    trigger,
    getValues,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      textField: "",
      invalidInput: "",
    },
    mode: "all",
    reValidateMode: "onChange",
    /* resetOptions: {
            keepDirtyValues: true, // user-interacted input will be retained
            keepErrors: true, // input errors will be retained with value update
        }, */
    resolver: yupResolver(sendOtpFormSchema(forUsername)),
  });

  const sendOtpHandler = useCallback(async () => {
    console.log(isBusy, isDisabled);

    if (isBusy || isDisabled) {
      return;
    }

    const isTextValid = await trigger("textField");
    console.log("isTextValid: ", isTextValid);

    if (!isTextValid) {
      return;
    }

    onSendOtp && onSendOtp(getValues("textField"));
  }, [onSendOtp]);

  return (
    <div className={className}>
      <div>
        <p className="text-base pl-4">{title}</p>
        <form className="w-full bg-white border rounded-lg border-[#1c1c2c] border-opacity-0 px-3 pt-4 pb-0 mb-4">
          <div>
            <div className="flex grid-cols-2 gap-2">
              <TextBox
                className="!m-0"
                value={value}
                info={info}
                label={label}
                name="textField"
                control={control}
                type={type}
                min={min}
                max={max}
                maxLength={maxLength}
                disabled={isDisabled}
                errors={errors}
              />
              <Button
                className="!w-[9rem]"
                variant="contained"
                type="button"
                isDisabled={isDisabled}
                onClick={sendOtpHandler}
              >
                Send OTP
              </Button>
            </div>
            {isDisabled && (
              <>
                <p className="text-xs pt-3 pl-2">
                  An OTP has been send to this mobile number
                </p>
                <p className="text-xs pl-2">please verify it below.</p>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default SendOtpForm;
